<template>
    <span>
        <resumodiariolistagem></resumodiariolistagem>
    </span>
</template>

<script>
import Resumodiariolistagem from '@/components/Resumo-Diario-Listagem';

export default {
    name: 'cadresumodiariolistagem',
    components: {
        Resumodiariolistagem
    }
};
</script>